import React, { useEffect, useState } from 'react';
import axios from 'axios';
import VisitorStats from './VisitorStats';

const StatisticsView = () => {
      return (
        <div style={{
            padding: '20px',
            zIndex: '10',
        }}>
            <h1 style={{ textAlign: 'center' }}>Visitor Statistics</h1>
            <VisitorStats 
            />
        </div>
    );
};

export default StatisticsView;
